module.exports = __webpack_public_path__ + "static/media/nani.bd392baf.mp3";